<template>
  <div class="bienvenida-page">
    <!-- Ornamentos animados superiores -->
    <div class="ubicacion-linea">
      <div ref="lineaDecorativa" class="linea-decorativa"></div>
    </div>

    <!-- Contenido -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <!-- Texto de bienvenida -->
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>

        <!-- Nombre decorativo con flores laterales 
        <div class="nombre-con-flores">
          <img src="@/assets/elementos2.png" alt="Flor izquierda" class="flor-lateral izquierda" />
          <div class="nuevo-texto" ref="nombreRef">
            Montserrat S
            <span class="e-wrapper">
              <span class="e-con-acento">a</span>
              <span class="falso-acento">´</span>
            </span>
            nchez Muro
          </div>          <img src="@/assets/elementos2.png" alt="Flor derecha" class="flor-lateral derecha" />
        </div>
-->
        <!-- Agradecimiento a los padres -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref("Dejo atrás una etapa y entro a una nueva, aunque a veces dudo o temo estoy llena de sueños, fe y esperanzas.\n\n En la vida hay momentos inolvidables que se atesoran en el corazón para siempre.\n\n Por esta razón, me gustaría compartan conmigo este día tan especial.");

    const mensajeRef = ref(null);
    const nombreRef = ref(null);
    const agradecimientoRef = ref(null);
    const ornamentoIzq = ref(null);
    const ornamentoDer = ref(null);

    const animateOnScroll = (element, animation) => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animation();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      observer.observe(element);
    };

    onMounted(() => {
      if (mensajeRef.value) {
        animateOnScroll(mensajeRef.value, () => {
          gsap.fromTo(mensajeRef.value, { opacity: 0, y: 50 }, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            delay: 0.2,
            ease: 'power3.out'
          });
        });
      }

      if (nombreRef.value) {
        animateOnScroll(nombreRef.value, () => {
          gsap.fromTo(nombreRef.value, { opacity: 0, y: 30 }, {
            opacity: 1,
            y: 0,
            duration: 1,
            delay: 0.4,
            ease: 'power2.out'
          });
        });
      }

      if (agradecimientoRef.value) {
        animateOnScroll(agradecimientoRef.value, () => {
          gsap.fromTo(agradecimientoRef.value, { opacity: 0, y: 30 }, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            delay: 0.5,
            ease: 'power2.out'
          });
        });
      }

      if (ornamentoIzq.value) {
        animateOnScroll(ornamentoIzq.value, () => {
          gsap.fromTo(ornamentoIzq.value, { opacity: 0, x: -100 }, {
            opacity: 1,
            x: 0,
            duration: 1.2,
            ease: 'power3.out'
          });
        });
      }

      if (ornamentoDer.value) {
        animateOnScroll(ornamentoDer.value, () => {
          gsap.fromTo(ornamentoDer.value, { opacity: 0, x: 100 }, {
            opacity: 1,
            x: 0,
            duration: 1.2,
            ease: 'power3.out'
          });
        });
      }
    });

    return {
      mensaje,
      mensajeRef,
      nombreRef,
      agradecimientoRef,
      ornamentoIzq,
      ornamentoDer
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin-top: 0px;
  margin-bottom: 0px;
  background-color: rgb(224,152,162);
}

.bienvenida-container {
  position: relative;
  width: 100%;
  min-height: auto;
  padding: 40px 20px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1;
}

.contenido-bienvenida {
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.mensaje-bienvenida {
  font-size: 19px;
  font-weight: 400;
  font-family: 'Josefin Sans', sans-serif;
  color: #ffff;
  white-space: pre-line;
  line-height: 2;
  margin-bottom: 20px;
  opacity: 0;
}

.mensaje-bienvenida:hover {
  color: rgba(122, 101, 97, 0.8);
}

.nombre-con-flores {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 10px;
}

.flor-lateral {
  width: 40px;
  height: auto;
  opacity: 0.95;
}

.nuevo-texto {
  font-size: 22px;
  font-family: 'FeelingPassionate';
  color: #c6949b;
  line-height: 2.4;
  opacity: 0;
  position: relative;
}

.e-wrapper {
  position: relative;
  letter-spacing: -0.35em;
  display: inline-block;
  margin: 0;
  padding: 0;
}

.e-con-acento {
  color: #c6949b;
  letter-spacing: -0.25em;
  position: relative;
  margin-left: -2px;
  padding: 0;
}

.falso-acento {
  position: absolute;
  top: 10px;
  left: 0em;
  font-size: 0.45em;
  font-weight: normal;
  color: #c6949b;
  z-index: 5;
  transform: rotate(15deg);
  pointer-events: none;
}

.agradecimiento {
  font-size: 20px;
  font-family: 'Dancing Script', cursive;
  color: #7a6a65;
  line-height: 1.8;
  opacity: 0;
  margin-top: 10px;
}

.nombre-padre,
.nombre-madre {
  font-family: 'Dancing Script', cursive;
  font-size: 19px;
  color: #5e4b47;
}

.ampersand {
  font-size: 22px;
  color: #b29b95;
  font-family: serif;
}
</style>